import { inject, Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { ActivateAccountParamsI, ActivatedAccountResponseI, LoginParamsI, LoginResponseI, RefreshTokenParamsI, RefreshTokenResponseI, ResetPasswordParamsI, Role, SetAccountPasswordParamsI, TwoFAVerification, UserDetail } from '../models/accounts.model';
import { Observable } from 'rxjs';
import { APIResponseI } from '../models/apiError.model';
import { StorageService } from './storage.service';
import { UserSettingService } from './user-setting.service';
import { Router } from '@angular/router';

@Injectable({
  providedIn:'root'
})
export class AuthService extends BaseService {
  private readonly storageService = inject(StorageService)
  private readonly userSettingService = inject(UserSettingService)
  private readonly router = inject(Router)
  constructor() {
    super();
  }

  login(params: LoginParamsI): Observable<LoginResponseI> {
    return this.http.post<LoginResponseI>(`${this.rootUrl}Account/Login`, params)
  }

  forgotPassword(params: { email: string }): Observable<APIResponseI> {
    return this.http.post<APIResponseI>(`${this.rootUrl}Account/ForgotPassword`, params)
  }

  resetPassword(params: ResetPasswordParamsI): Observable<APIResponseI> {
    return this.http.post<APIResponseI>(`${this.rootUrl}Account/ResetPassword`, params)
  }

  activateAccount(params: ActivateAccountParamsI): Observable<ActivatedAccountResponseI> {
    return this.http.post<ActivatedAccountResponseI>(this.rootUrl + 'Account/ActivateAccount', params)
  }

  setAccountPassword(params: SetAccountPasswordParamsI): Observable<APIResponseI> {
    return this.http.post<APIResponseI>(this.rootUrl + 'Account/SetAccountPassword', params)
  }

  getRefreshToken(params: RefreshTokenParamsI): Observable<RefreshTokenResponseI> {
    return this.http.post<RefreshTokenResponseI>(`${this.rootUrl}Account/Refresh`, params)
  }

  verifyOTP(params: TwoFAVerification): Observable<LoginResponseI>{
    return this.http.post <LoginResponseI>(`${this.rootUrl}TwoFactorAuth/TwoFaLogin`, params)
  }
  resendOTP(params:{email:string}){
    return this.http.post(`${this.rootUrl}TwoFactorAuth/ResendTwoFa`, params);
  }

  logout(): Observable<APIResponseI> {
    return this.http.post<APIResponseI>(`${this.rootUrl}Account/Logout`, null)
  }

  setUserData(userData: UserDetail){
    this.userSettingService.sendData({ ...userData})

    this.storageService.add('userToken', userData.accessToken);
    this.storageService.add('userRole', userData.userRole);
    this.storageService.add('username', userData.userName);
    this.storageService.add('refreshToken', userData.refreshToken)
    
    if (userData.organizationId !== null) {
      this.storageService.add('organizationId', userData.organizationId);
    }
    if (userData.organizationName !== null) {
      this.storageService.add('organizationName', userData.organizationName);
    }
    if (userData.masjidName !== null) {
      this.storageService.add('masjidName', userData.masjidName);
    }
    if(userData.masjidId && (userData.userRole == Role.MessageEditor || userData.userRole == Role.Editor)){
      this.storageService.add('id', userData.masjidId)
    }

    this.navigateBasedOnRole(userData)
  }
  navigateBasedOnRole(userData: UserDetail) {
    switch (userData.userRole) {
      case Role.Admin:
        this.router.navigate(['/dashboard/allmasjids']);
        break;
      case Role.MasterEditor:
        this.router.navigate(['/dashboard/organization-masajids/', userData.organizationId]);
        break;
      case Role.MessageEditor:
        this.router.navigate(['/dashboard/masjid/', userData.masjidId]);
        break;
      default:
        this.router.navigate(['/dashboard/masjid/', userData.masjidId]);
        break;
    }

  }
}
